import { Typography } from '@design-system/components/typography/typography';
import { BundleDetailsCard } from './BundleDetailsCard';
import { BundlesContentTable } from './BundlesContentTable';
import { BundlesCards } from '../viewModel/subscriptionBundle.vm.mapper';
import { SubscriptionBundlesVM } from '../viewModel/subscriptionBundles.viewModel';
import { SubscriptionPriceModal } from './editExclusiveBundle/SubscriptionPriceModal';
import { PlatformBundleModal } from './editPlatformBundle/PlatformBundleModal';
import { SendPushNotificationModal } from './editPlatformBundle/SendPushNotificationModal';
import { MigrateToBundle } from './migration/MigrateToBundle';
import { ConfirmPriceChangeModal } from './editExclusiveBundle/ConfirmPriceChangeModal';
import { ConfirmPriceDisableModal } from './editExclusiveBundle/ConfirmPriceDisableModal';
import { MigrationModal } from './migration/modal/MigrationModal';
import { EmptyState } from './createSubscriptionBundle/EmptyState';
import { CreateModal } from './createSubscriptionBundle/emptyStateModal/CreateModal';
import { Alert } from '@design-system/components/alert/alert';
import { LinksModal } from '@client/new/common/linksModal/linksModal';
import { ConfirmPublishModal } from '../../common/ConfirmPublishModal';
import { ConfirmUnsavedChangesModal } from '../../otp/view/ConfirmUnsavedChangesModal';
import { ExclusiveOfferPlaceholderCard } from './ExclusiveOfferPlaceholderCard';
import { StartExclusiveBundleModal } from './createSubscriptionBundle/startExclusiveBundleModal/StartExclusiveBundleModal';

export type SubscriptionBundlesProps = {
  cards: BundlesCards;
} & Pick<
  SubscriptionBundlesVM,
  | 'list'
  | 'priceEditModal'
  | 'confirmPriceModal'
  | 'confirmPriceDisableModal'
  | 'confirmPublishModal'
  | 'confirmSaveModal'
  | 'emptyState'
  | 'platformBundleModal'
  | 'unsavedChangesModal'
  | 'pushNotificationModal'
  | 'migrateToBundle'
  | 'hideSubscriptionBundles'
  | 'showEmptyState'
  | 'showMigrateToBundle'
  | 'createBundleModal'
  | 'linksModal'
  | 'dispatch'
  | 'exclusiveBundlePlaceholder'
  | 'startExlusiveBundleModal'
>;

export const SubscriptionBundles = ({
  showEmptyState,
  emptyState,
  cards,
  exclusiveBundlePlaceholder,
  priceEditModal,
  confirmPriceModal,
  confirmPriceDisableModal,
  confirmPublishModal,
  confirmSaveModal,
  hideSubscriptionBundles,
  platformBundleModal,
  unsavedChangesModal,
  pushNotificationModal,
  migrateToBundle,
  showMigrateToBundle,
  createBundleModal,
  linksModal,
  dispatch,
  startExlusiveBundleModal,
  ...p
}: SubscriptionBundlesProps) => {
  if (hideSubscriptionBundles) return null;

  return (
    <div className="flex flex-col gap-6">
      <div className="flex justify-between items-center">
        <Typography variant="body" size="medium" color="N-80" fontWeight="bold">
          Subscription Offers
        </Typography>
      </div>
      {showMigrateToBundle ? (
        <>
          <MigrateToBundle startMigration={migrateToBundle.startMigration} />
          <MigrationModal
            {...migrateToBundle.migrationModal}
            dispatch={dispatch}
          />
        </>
      ) : showEmptyState ? (
        <>
          <EmptyState {...emptyState} />
          <CreateModal {...createBundleModal} dispatch={dispatch} />
        </>
      ) : (
        <>
          <div className="flex flex-col gap-4">
            {migrateToBundle.showMigrationAlert && (
              <Alert
                variant="info"
                allowClose={true}
                onClose={migrateToBundle.onMigrationAlertClose}
                title="Make your Exclusive subscription worth it!"
                details="Your Exclusive subscription has access to all the subscription programs on your channel. You can decide what's available to your Platform subscription users. Make sure your Exclusive subscription has Exclusive value!"
              />
            )}
            <div className="flex flex-col md:flex-row gap-4 w-full">
              {exclusiveBundlePlaceholder.show && (
                <ExclusiveOfferPlaceholderCard
                  create={exclusiveBundlePlaceholder.create}
                />
              )}
              {cards.map((card) => (
                <BundleDetailsCard {...card} key={card.bundleId} />
              ))}
            </div>
            <BundlesContentTable {...p} />
          </div>
          <SubscriptionPriceModal {...priceEditModal} />
          <ConfirmPriceChangeModal {...confirmPriceModal} />
          <ConfirmPriceDisableModal {...confirmPriceDisableModal} />
          <ConfirmPublishModal {...confirmPublishModal} />
          <ConfirmPublishModal {...confirmSaveModal} />
          <PlatformBundleModal {...platformBundleModal} />
          <ConfirmUnsavedChangesModal {...unsavedChangesModal} />
          <SendPushNotificationModal {...pushNotificationModal} />
          <StartExclusiveBundleModal
            {...startExlusiveBundleModal}
            dispatch={dispatch}
          />
        </>
      )}
      <LinksModal {...linksModal} />
    </div>
  );
};
